import { useEffect } from 'react';
import { Box, Button, IconButton, Paper, Stack, Typography } from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { useNavigate } from 'react-router';
import { useAppContext } from '../../contexts/AppContext';
import '../Customer/CustomerScreens.scss';

export default function Logout() {
  const navigate = useNavigate();
  const { logoutUser } = useAppContext();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleLogout = () => {
    logoutUser();
    navigate('/');
  };

  return (
    <Box className='customer-screen'>
      <Box className='customer-shell'>
        <Box className='customer-topbar'>
          <IconButton className='customer-iconButton' onClick={() => navigate(-1)}>
            <ArrowBackRoundedIcon />
          </IconButton>
          <Typography className='customer-topbarTitle'>Log Out</Typography>
          <Box sx={{ width: 46 }} />
        </Box>

        <Paper className='customer-card' sx={{ p: 3, textAlign: 'center' }}>
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: '24px',
              background: 'linear-gradient(180deg, #ff8d78 0%, #ff5c67 100%)',
              color: '#fff',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 2,
            }}
          >
            <LogoutRoundedIcon />
          </Box>
          <Typography sx={{ fontWeight: 700, fontSize: '1.3rem', mb: 1 }}>
            Are you sure you want to log out?
          </Typography>
          <Typography className='customer-muted' sx={{ mb: 2.5 }}>
            You can sign in again anytime to access your orders, saved addresses, and favorites.
          </Typography>
          <Stack spacing={1.25}>
            <Button className='customer-actionButton customer-actionButton--primary' onClick={handleLogout}>
              Confirm logout
            </Button>
            <Button className='customer-actionButton customer-actionButton--soft' onClick={() => navigate('/profile')}>
              Cancel
            </Button>
          </Stack>
        </Paper>
      </Box>
    </Box>
  );
}
